import { type Product } from 'types/products/productTypes'
import { ProductTile } from './components/product-tile/ProductTile'
import { HeaderView } from '../header-view/HeaderView'
import { useProductOrderContext } from '../../context'
import './newProductsOrderView.scss'

interface Props {
  onSelectProduct: (product: Product) => void
}

export const NewProductsOrderView = ({ onSelectProduct }: Props) => {
  const { category, productList } = useProductOrderContext()
  const title = `New ${
    category === 'moud' ? 'OUD'
    : category === 'MenopauseHormoneTherapy' ? 'MHT'
    : 'Weight Treatment'
  } Order`
  return (
    <div className='new-product-order-view-main-container'>
      <HeaderView title={title} />

      <div className='new-product-order-view-container'>
        {/*
         // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
        {productList.length === 0 ?
          <div className='new-product-order-view-text'>No products available</div>
        : (
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          productList[0].Products[0].PriceRange.From === productList[0].Products[0].PriceRange.To &&
          // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
          productList[0].Products[0].PriceRange.From === 0
        ) ?
          null
        : <div className='new-product-order-view-text'>
            All prices shown do not yet reflect any visit or accounts credits, which will be applied prior to payment.
          </div>
        }

        <div className='new-product-order-view-grouped-list-container'>
          {/*
           // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered */}
          {productList.map((products) => (
            <div className='new-product-order-view-list-container' key={products.Group}>
              {products.Group}
              <div className='new-product-order-view-product-list-container'>
                {products.Products.map((product) => (
                  <ProductTile
                    key={`${product.Brand}-${product.Name}-${product.Duration}`}
                    product={product}
                    onClick={() => {
                      onSelectProduct(product)
                    }}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
